import api from './api';
import { PromoCode, CreatePromoCodeDto, UpdatePromoCodeDto } from '../types/promo-code.types';

export const promoCodeService = {
  async getAllPromoCodes(): Promise<PromoCode[]> {
    const response = await api.get<PromoCode[]>('/promo-codes');
    return response.data;
  },

  async createPromoCode(data: CreatePromoCodeDto): Promise<PromoCode> {
    const response = await api.post<PromoCode>('/promo-codes', data);
    return response.data;
  },

  async updatePromoCodeStatus(id: number, data: UpdatePromoCodeDto): Promise<PromoCode> {
    const response = await api.patch<PromoCode>(`/promo-codes/${id}`, data);
    return response.data;
  },
};
